module.exports = __webpack_public_path__ + "2d4a9f06fbb40f63bed6313fc512375a.svg";